<template>
  <v-app class="custom_bg">
    <v-container>
      <v-row>
        <v-col cols="12" md="12">
          <v-card>
            <v-card-title class="px-6">Add Product</v-card-title>
            <v-card-text>
              <v-form v-model="form" ref="form">
                <v-col cols="12" md="6" class="py-0">
                  <span class="text-body-1">Product Name</span>
                  <v-text-field
                    outlined
                    color="primary"
                    dense
                    :rules="[rules.required]"
                    v-model="name"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <span class="text-body-1"> Select Product Type</span>
                  <v-select
                    :items="items"
                    v-model="type"
                    outlined
                    :rules="[rules.required]"
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6" class="py-0" v-if="type === 'goods'">
                  <span class="text-body-1">Quantity</span>
                  <v-text-field
                    outlined
                    color="primary"
                    dense
                    type="number"
                    v-model="quantity"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <span class="text-body-1">Unit Price</span>
                  <v-text-field
                    outlined
                    color="primary"
                    type="number"
                    suffix=".00"
                    :rules="[rules.required]"
                    dense
                    v-model="price"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <span class="text-body-1">Description</span>
                  <v-text-field
                    outlined
                    color="primary"
                    :rules="[rules.required]"
                    dense
                    v-model="describtion"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <v-card-actions>
                    <v-snackbar v-model="alert" color="success">
                      Product added successfully
                    </v-snackbar>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      @click="create()"
                      :loading="loading"
                      class="text-capitalize"
                      >Create</v-btn
                    >
                  </v-card-actions>
                </v-col>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Home",

  components: {},
  data: () => ({
    items: ["goods", "services"],
    name: "",
    type: "",
    loading: false,
    quantity: "",
    form: false,
    alert: false,
    describtion: "",
    price: "",
    rules: {
      length: (len) => (v) =>
        (v || "").length >= len || `Invalid character length, required ${len}`,
      required: (v) => !!v || "This field is required",
      password: (value) =>
        (value && value.length >= 5) || "Minimum length is 5 characters",
    },
  }),

  methods: {
    create() {
      const data = {
        name: this.name,
        price: this.price,
        description: this.describtion,
        type: this.type,
        qty: this.quantity,
      };
      if (this.$refs.form.validate()) {
        this.loading = true;
        fetch("https://receipt.drecsoft.com/api/v1/inventory/create-product", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.currentUser}`,
          },
          body: JSON.stringify(data),
        })
          .then((res) => {
            this.loading = false;
            console.log(res);
            this.alert = true;
            setTimeout(() => {
              this.$router.go();
            }, 1000);
          })
          .catch((err) => {
            this.loading = false;
            alert(err);
            console.log(err);
          });
      }
    },
  },

  computed: {
    ...mapGetters(["getUser", "currentUser"]),
  },
};
</script>

<style  scoped>
.custom_bg {
  background: #f6f7ff;
}
</style>
